import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import CommentItem from './CommentItem';
interface DatabaseComment {
  id: string;
  created_at: string;
  content: string;
  story_id: string;
  user_id: string;
  author_name: string;
  author_avatar?: string;
  likes: number;
}
interface CommentsListProps {
  loading: boolean;
  comments: DatabaseComment[];
  user: any | null;
  userLikes: string[];
  handleLikeComment: (commentId: string) => void;
  signInWithGoogle: () => Promise<void>;
  textColor: string;
}
const CommentsList: React.FC<CommentsListProps> = ({
  loading,
  comments,
  user,
  userLikes,
  handleLikeComment,
  signInWithGoogle,
  textColor
}) => {
  if (loading) {
    return <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>;
  }
  if (comments.length === 0) {
    return;
  }
  return <div className="space-y-6">
      {comments.map(comment => <CommentItem key={comment.id} comment={comment} currentUser={user} onLike={handleLikeComment} userLikes={userLikes} />)}
    </div>;
};
export default CommentsList;